// extracted by mini-css-extract-plugin
module.exports = {"main":"main-module--main--11Wwn","box":"main-module--box--SUePX","btn":"main-module--btn--3dEOH","goTop":"main-module--go-top--1KhoY","goHome":"main-module--go-home--2pLXG"};